import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  equalsLong28bsrfhwvd686 as equalsLong,
  protoOf180f3jzyo7rfj as protoOf,
  Monotonic_instance2att21stfwfpk as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs593ou6p5l5hu as ValueTimeMark__elapsedNow_impl_eonqvs,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  ArrayList3it5z8td81qkl as ArrayList,
  HashSet2dzve9y63nf0v as HashSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  sort15ai02l4kxbfa as sort,
  coerceAtLeast3jlgfquiyquc9 as coerceAtLeast,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  printStackTrace18lnx7a39cni as printStackTrace,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  toDuration28gf6ughsr3vf as toDuration_0,
  CancellationException3b36o9qz53rgr as CancellationException,
  constructCallableReference23y65rf941mch as constructCallableReference,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  createFailure8paxfkfa5dc7 as createFailure,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance1cfwgdmm6vbbh as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea92zjvgyei8ws1 as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
  Continuation1aa2oekvx7jm7 as Continuation,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  println2shhhgwwt4c61 as println,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from './kotlinx-atomicfu.mjs';
import {
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  compareTo2tbidk88xyn1w as compareTo_0,
  FastDuration__minus_impl_evs2373tu2z52vjijn3 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72w7b7e2su2u98 as FastDuration__compareTo_impl_4fhnj7,
  FastDuration__compareTo_impl_4fhnj7xnw2bvpwwoqp as FastDuration__compareTo_impl_4fhnj7_0,
  FastDuration__plus_impl_q1enab2deeoiodbc4f9 as FastDuration__plus_impl_q1enab,
  get_fast37cu8s8qwnuyi as get_fast,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__minus_impl_evs2371up2plcsbrg6i as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  delayvyed5wvki0ic as delay,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  withContextqz5k6d9p9xx5 as withContext,
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
} from './kotlinx-coroutines-core.mjs';
import { FastArrayListw5fr1wlp4slq as FastArrayList } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class NonRecursiveLock {
  constructor() {
    this.i9w_1 = new Object();
  }
}
class BaseLockWithNotifyAndWait {}
function notify$default(unit, $super) {
  unit = unit === VOID ? Unit_instance : unit;
  var tmp;
  if ($super === VOID) {
    this.q9w(unit);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super.q9w;
    tmp = tmp_0.call(this, Unit_instance);
  }
  return tmp;
}
class LockImpl {
  constructor() {
    this.j9w_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.k9w_1 = get_atomicfu$reentrantLock();
    this.l9w_1 = atomic$long$1(new Long(0, 0));
    this.m9w_1 = atomic$int$1(0);
  }
  n9w() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.k9w_1;
    this.m9w_1.atomicfu$incrementAndGet();
    this.l9w_1.kotlinx$atomicfu$value = _NativeThread___get_id__impl__jog4wy(Companion_instance_0.o9w());
  }
  p9w() {
    // Inline function 'kotlin.check' call
    if (!(this.m9w_1.kotlinx$atomicfu$value > 0)) {
      var message = 'Must unlock inside a synchronization block';
      throw IllegalStateException.o(toString(message));
    }
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.k9w_1;
    this.m9w_1.atomicfu$decrementAndGet();
  }
  q9w(unit) {
    if (!get_isSupported(Companion_instance_3))
      throw UnsupportedOperationException.k9();
    // Inline function 'kotlin.check' call
    if (!(this.m9w_1.kotlinx$atomicfu$value > 0)) {
      var message = 'Must notify inside a synchronization block';
      throw IllegalStateException.o(toString(message));
    }
    // Inline function 'kotlin.check' call
    if (!equalsLong(this.l9w_1.kotlinx$atomicfu$value, _NativeThread___get_id__impl__jog4wy(Companion_instance_0.o9w()))) {
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.o(toString(message_0));
    }
    this.j9w_1.kotlinx$atomicfu$value = true;
  }
  s9w(time) {
    if (!get_isSupported(Companion_instance_3))
      throw UnsupportedOperationException.k9();
    var lockCount = this.m9w_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.check' call
    if (!(lockCount > 0)) {
      var message = 'Must wait inside a synchronization block';
      throw IllegalStateException.o(toString(message));
    }
    var start = Monotonic_instance.ck();
    this.j9w_1.kotlinx$atomicfu$value = false;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < lockCount)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.p9w();
      }
       while (inductionVariable < lockCount);
    // Inline function 'kotlin.check' call
    if (!(this.m9w_1.kotlinx$atomicfu$value === 0)) {
      var message_0 = 'Must unlock all locks';
      throw IllegalStateException.o(toString(message_0));
    }
    try {
      // Inline function 'korlibs.concurrent.thread.sleepWhile' call
      var stepTime = get_fastMilliseconds(1.0);
      $l$loop: while (!this.j9w_1.kotlinx$atomicfu$value && compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0) {
        sleep(Companion_instance_0, stepTime, false);
      }
    }finally {
      // Inline function 'kotlin.repeat' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < lockCount)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.n9w();
        }
         while (inductionVariable_0 < lockCount);
    }
  }
}
class Companion {
  t9w() {
    return get_NativeThreadThread_isSupported();
  }
  o9w() {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_current());
  }
  u9w(name, isDaemon, priority, code) {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_start(name, isDaemon, priority, code));
  }
  v9w(time) {
    return NativeThreadThread_sleep(time);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.w9w_1 = _NativeThreadPriority___init__impl__qecm6c(0.0);
    this.x9w_1 = _NativeThreadPriority___init__impl__qecm6c(0.25);
    this.y9w_1 = _NativeThreadPriority___init__impl__qecm6c(0.5);
    this.z9w_1 = _NativeThreadPriority___init__impl__qecm6c(0.75);
    this.a9x_1 = _NativeThreadPriority___init__impl__qecm6c(0.9);
    this.b9x_1 = _NativeThreadPriority___init__impl__qecm6c(1.0);
  }
}
class FixedPoolNativeThreadDispatcher extends CoroutineDispatcher {
  constructor(numThreads, name, priority, isDaemon, preciseTimings) {
    return new.target.k9x(numThreads, name, priority, isDaemon, preciseTimings);
  }
  static k9x(numThreads, name, priority, isDaemon, preciseTimings) {
    name = name === VOID ? 'FixedPoolNativeThreadDispatcher' : name;
    priority = priority === VOID ? Companion_getInstance_1().y9w_1 : priority;
    isDaemon = isDaemon === VOID ? true : isDaemon;
    preciseTimings = preciseTimings === VOID ? false : preciseTimings;
    var $this = this.q1t();
    $this.d9x_1 = numThreads;
    $this.e9x_1 = name;
    $this.f9x_1 = priority;
    $this.g9x_1 = isDaemon;
    $this.h9x_1 = preciseTimings;
    // Inline function 'kotlin.check' call
    if (!($this.d9x_1 >= 1)) {
      var message = 'numThreads should be >= 1';
      throw IllegalStateException.o(toString(message));
    }
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.d9x_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = NativeThreadDispatcher.y9x($this.e9x_1 + '-' + tmp_3, $this.f9x_1, $this.g9x_1, $this.h9x_1);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.i9x_1 = tmp_2;
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.i9x_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$6 = _NativeThread___get_id__impl__jog4wy(item.w9x_1);
      destination.d2(tmp$ret$6);
    }
    tmp_4.j9x_1 = HashSet.nb(destination);
    return $this;
  }
  f7() {
    var indexedObject = this.i9x_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var dispatcher = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      dispatcher.f7();
    }
  }
  r1t(context) {
    return !this.j9x_1.w2(_NativeThread___get_id__impl__jog4wy(Companion_instance_0.o9w()));
  }
  s1t(context, block) {
    var tmp0 = this.i9x_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0)
        throw NoSuchElementException.w7();
      var minElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$0 = minElem;
        break $l$block;
      }
      var minValue = minElem.z9x();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          var v = e.z9x();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$0 = minElem;
    }
    tmp$ret$0.s1t(context, block);
  }
  t1t(context, block) {
    var tmp0 = this.i9x_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0)
        throw NoSuchElementException.w7();
      var minElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$0 = minElem;
        break $l$block;
      }
      var minValue = minElem.z9x();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          var v = e.z9x();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$0 = minElem;
    }
    tmp$ret$0.t1t(context, block);
  }
  i1u(timeMillis, continuation) {
    var tmp0 = this.i9x_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0)
        throw NoSuchElementException.w7();
      var minElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$0 = minElem;
        break $l$block;
      }
      var minValue = minElem.a9y();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          var v = e.a9y();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$0 = minElem;
    }
    tmp$ret$0.i1u(timeMillis, continuation);
  }
  j1u(timeMillis, block, context) {
    var tmp0 = this.i9x_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0)
        throw NoSuchElementException.w7();
      var minElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$0 = minElem;
        break $l$block;
      }
      var minValue = minElem.a9y();
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          var v = e.a9y();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$0 = minElem;
    }
    return tmp$ret$0.j1u(timeMillis, block, context);
  }
}
class TimedTask {
  constructor(dispatcher, time, task, block) {
    this.b9y_1 = dispatcher;
    this.c9y_1 = time;
    this.d9y_1 = task;
    this.e9y_1 = block;
  }
  f9y(other) {
    return FastDuration__compareTo_impl_4fhnj7_0(this.c9y_1, this.c9y_1);
  }
  d(other) {
    return this.f9y(other instanceof TimedTask ? other : THROW_CCE());
  }
  u1o() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.b9y_1.s9x_1;
    this.b9y_1.t9x_1.z4(this);
  }
}
class NativeThreadDispatcher extends CoroutineDispatcher {
  constructor(name, priority, isDaemon, preciseTimings) {
    return new.target.y9x(name, priority, isDaemon, preciseTimings);
  }
  static y9x(name, priority, isDaemon, preciseTimings) {
    name = name === VOID ? 'NativeThreadDispatcher' : name;
    priority = priority === VOID ? Companion_getInstance_1().y9w_1 : priority;
    isDaemon = isDaemon === VOID ? true : isDaemon;
    preciseTimings = preciseTimings === VOID ? false : preciseTimings;
    var $this = this.q1t();
    $this.m9x_1 = name;
    $this.n9x_1 = priority;
    $this.o9x_1 = isDaemon;
    $this.p9x_1 = preciseTimings;
    $this.q9x_1 = true;
    $this.r9x_1 = new Lock();
    $this.s9x_1 = new Object();
    $this.t9x_1 = ArrayDeque.ul();
    $this.u9x_1 = new Lock();
    $this.v9x_1 = ArrayDeque.ul();
    var tmp = $this;
    var tmp4_name = $this.m9x_1;
    var tmp5_priority = $this.n9x_1;
    var tmp6_isDaemon = $this.o9x_1;
    tmp.w9x_1 = Companion_instance_0.u9w(tmp4_name, tmp6_isDaemon, tmp5_priority, NativeThreadDispatcher$thread$lambda($this));
    $this.x9x_1 = Monotonic_instance.ck();
    return $this;
  }
  z9x() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = this.u9x_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        tmp$ret$1 = this.v9x_1.rl_1;
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
    return tmp$ret$1;
  }
  a9y() {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.s9x_1;
    return this.t9x_1.rl_1;
  }
  r1t(context) {
    return equalsLong(_NativeThread___get_id__impl__jog4wy(Companion_instance_0.o9w()), _NativeThread___get_id__impl__jog4wy(this.w9x_1));
  }
  f7() {
    // Inline function 'korlibs.concurrent.lock.notify' call
    var this_0 = this.r9x_1;
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n9w();
      try {
        this.q9x_1 = false;
        // Inline function 'kotlin.also' call
        this_0.r9w();
        break $l$block;
      }finally {
        this_0.p9w();
      }
    }
  }
  s1t(context, block) {
    // Inline function 'korlibs.concurrent.lock.notify' call
    var this_0 = this.r9x_1;
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.n9w();
      try {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var tmp0 = this.u9x_1;
        $l$block: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          tmp0.n9w();
          try {
            this.v9x_1.d2(block);
            break $l$block;
          }finally {
            tmp0.p9w();
          }
        }
        // Inline function 'kotlin.also' call
        this_0.r9w();
        break $l$block_0;
      }finally {
        this_0.p9w();
      }
    }
  }
  t1t(context, block) {
    super.t1t(context, block);
  }
  i1u(timeMillis, continuation) {
    _sched(this, timeMillis, continuation, null);
  }
  j1u(timeMillis, block, context) {
    return _sched(this, timeMillis, null, block);
  }
}
class onCancel$$inlined$AutoCloseable$1 {
  constructor($running) {
    this.g9y_1 = $running;
  }
  f7() {
    this.g9y_1._v = false;
    return Unit_instance;
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_2 = this;
    this.h9y_1 = new PreferSyncIo(true);
    this.i9y_1 = new PreferSyncIo(false);
  }
  j9y(preferSyncIo) {
    return preferSyncIo === true ? this.h9y_1 : this.i9y_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_2();
    this.k9y_1 = preferSyncIo;
  }
  j3() {
    return Companion_getInstance_2();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.k9y_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.k9y_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.k9y_1 === tmp0_other_with_cast.k9y_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.q9y_1 = onRegister;
    this.r9y_1 = FastArrayList.f9v();
    this.s9y_1 = FastArrayList.f9v();
    this.t9y_1 = 0;
  }
  b9z() {
    return this.r9y_1.s2();
  }
  c9z() {
    return this.b9z() > 0;
  }
  u9y(once, handler) {
    this.q9y_1();
    var node = new Node(this, once, handler);
    this.r9y_1.d2(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  p9y(handler) {
    return this.u9y(true, handler);
  }
  v9y(handler) {
    return this.u9y(false, handler);
  }
  w9y(handler) {
    return this.v9y(handler);
  }
  x9y(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.r9y_1.n1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.t9y_1 = this.t9y_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.r9y_1;
        var n = 0;
        var m = 0;
        while (n < this_0.s2()) {
          if (m >= 0 && !(m === n)) {
            this_0.e5(m, this_0.u2(n));
          }
          var node = this_0.u2(n);
          var remove = node.y9y_1;
          node.z9y_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.s2() > m) {
          this_0.g5(this_0.s2() - 1 | 0);
        }
      }finally {
        this.t9y_1 = this.t9y_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.s9y_1.n1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.s9y_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.s2()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.e5(m_0, this_1.u2(n_0));
            }
            var it = this_1.u2(n_0);
            this.r9y_1.z4(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.s2() > m_0) {
            this_1.g5(this_1.s2() - 1 | 0);
          }
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  h9z(handler) {
    return this.u9y(false, handler);
  }
  i9z(handler) {
    return this.h9z(handler);
  }
  *j9z(value, $completion) {
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.r9y_1.n1()) {
        break $l$block;
      }
      try {
        this.t9y_1 = this.t9y_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.r9y_1;
        var n = 0;
        var m = 0;
        while (n < this_0.s2()) {
          if (m >= 0 && !(m === n)) {
            this_0.e5(m, this_0.u2(n));
          }
          var node = this_0.u2(n);
          var remove = node.y9y_1;
          yield* node.z9y_1(value, $completion);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.s2() > m) {
          this_0.g5(this_0.s2() - 1 | 0);
        }
      }finally {
        this.t9y_1 = this.t9y_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.s9y_1.n1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.s9y_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.s2()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.e5(m_0, this_1.u2(n_0));
            }
            var it = this_1.u2(n_0);
            this.r9y_1.z4(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.s2() > m_0) {
            this_1.g5(this_1.s2() - 1 | 0);
          }
        }
      }
    }
    return Unit_instance;
  }
}
class Node {
  constructor($outer, once, item) {
    this.a9z_1 = $outer;
    this.y9y_1 = once;
    this.z9y_1 = item;
  }
  f7() {
    if (this.a9z_1.t9y_1 > 0) {
      this.a9z_1.s9y_1.d2(this);
    } else {
      this.a9z_1.r9y_1.z4(this);
    }
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  constructor($suspendCount) {
    return new.target.n9z($suspendCount);
  }
  static n9z($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.m9z_1 = $suspendCount;
    var $this = this.jp(Key_instance, $box);
    $this.l9z_1 = Key_instance;
    return $this;
  }
  j3() {
    return this.l9z_1;
  }
  be(continuation) {
    // Inline function 'kotlin.also' call
    var _unary__edvuaz = this.m9z_1._v;
    this.m9z_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  i1u(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.qd(tmp$ret$1);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.p9z_1 = $resultEx;
    this.q9z_1 = $completed;
    this.r9z_1 = $rresult;
    var tmp = this;
    tmp.o9z_1 = runBlockingNoSuspensions$1$context$1.n9z($suspendCount);
  }
  od() {
    return this.o9z_1;
  }
  s9z(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.p9z_1._v = exception;
      this.q9z_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp0_elvis_lhs = _Result___get_value__impl__bjfvqg(result);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_0 = Unit_instance;
        var tmp_1;
        if (!(Unit_instance == null)) {
          tmp_1 = Unit_instance;
        } else {
          tmp_1 = THROW_CCE();
        }
        tmp = tmp_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var rvalue = tmp;
      this.r9z_1._v = rvalue;
      this.q9z_1._v = true;
    }
  }
  qd(result) {
    return this.s9z(result);
  }
}
class Companion_2 {}
class Lock extends LockImpl {}
//endregion
function get_isSupported(_this__u8e3s4) {
  return Companion_instance_0.t9w();
}
function _NativeThread___init__impl__p2udts(native) {
  return native;
}
function _NativeThread___get_native__impl__f44o82($this) {
  return $this;
}
function _NativeThread___get_id__impl__jog4wy($this) {
  return NativeNativeThread_getId(_NativeThread___get_native__impl__f44o82($this));
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function _NativeThreadPriority___init__impl__qecm6c(ratio) {
  return ratio;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function sleep(_this__u8e3s4, time, exact) {
  if (exact) {
    sleepExact(_this__u8e3s4, time);
  } else {
    Companion_instance_0.v9w(time);
  }
}
function sleepExact(_this__u8e3s4, time) {
  var start = Monotonic_instance.ck();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  var imprecision = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
  var javaSleep = FastDuration__minus_impl_evs237(time, imprecision);
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance();
  var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  if (FastDuration__compareTo_impl_4fhnj7(javaSleep, tmp$ret$1) >= 0) {
    Companion_instance_0.v9w(javaSleep);
  }
  // Inline function 'korlibs.concurrent.thread.Companion.spinWhile' call
  // Inline function 'korlibs.concurrent.thread.NativeThreadThread_spinWhile' call
  $l$loop: while (compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0) {
  }
}
function _sched($this, timeMillis, continuation, block) {
  var tmp = now($this);
  // Inline function 'korlibs.time.fastMilliseconds' call
  var tmp$ret$0 = get_fastMilliseconds(numberToDouble(timeMillis));
  var task = new TimedTask($this, FastDuration__plus_impl_q1enab(tmp, tmp$ret$0), continuation, block);
  // Inline function 'korlibs.concurrent.lock.notify' call
  var this_0 = $this.r9x_1;
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.n9w();
    try {
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      $this.s9x_1;
      var firstTask = $this.t9x_1.wl();
      if (firstTask == null || FastDuration__compareTo_impl_4fhnj7_0(task.c9y_1, firstTask.c9y_1) < 0) {
        $this.t9x_1.xl(task);
      } else {
        $this.t9x_1.yl(task);
        sort($this.t9x_1);
      }
      // Inline function 'kotlin.also' call
      this_0.r9w();
      break $l$block;
    }finally {
      this_0.p9w();
    }
  }
  return task;
}
function now($this) {
  return get_fast(ValueTimeMark__elapsedNow_impl_eonqvs($this.x9x_1));
}
function NativeThreadDispatcher$thread$lambda(this$0) {
  return () => {
    $l$loop: while (this$0.q9x_1) {
      try {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var tmp0 = this$0.r9x_1;
        $l$block: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          tmp0.n9w();
          try {
            if (this$0.v9x_1.n1()) {
              // Inline function 'kotlinx.atomicfu.locks.synchronized' call
              this$0.s9x_1;
              var firstTask = this$0.t9x_1.wl();
              var time = !(firstTask == null) ? FastDuration__minus_impl_evs237_0(firstTask.c9y_1, now(this$0)) : get_fastMilliseconds_0(10000);
              this$0.r9x_1.s9w(coerceAtLeast(new FastDuration(time), new FastDuration(get_fastMilliseconds(0.1))).f9w_1);
            }
            break $l$block;
          }finally {
            tmp0.p9w();
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
        } else {
          throw $p;
        }
      }
      if (!this$0.q9x_1)
        break $l$loop;
      try {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var tmp0_0 = this$0.u9x_1;
        var tmp$ret$6;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          tmp0_0.n9w();
          try {
            tmp$ret$6 = this$0.v9x_1.am();
            break $l$block_0;
          }finally {
            tmp0_0.p9w();
          }
        }
        var task = tmp$ret$6;
        if (task == null)
          null;
        else {
          task.c1t();
        }
        // Inline function 'kotlin.run' call
        var $this$run = this$0;
        $l$loop_0: while (true) {
          // Inline function 'kotlinx.atomicfu.locks.synchronized' call
          $this$run.s9x_1;
          var tryTask = $this$run.t9x_1.wl();
          var tmp0_elvis_lhs = !(tryTask == null) && FastDuration__compareTo_impl_4fhnj7_0(now($this$run), tryTask.c9y_1) >= 0 ? $this$run.t9x_1.zl() : null;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var task_0 = tmp;
          var tmp1_safe_receiver = task_0.d9y_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$13 = _Result___init__impl__xyqfz8(Unit_instance);
            tmp1_safe_receiver.qd(tmp$ret$13);
          }
          var tmp2_safe_receiver = task_0.e9y_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.c1t();
          }
        }
      } catch ($p_0) {
        if ($p_0 instanceof Error) {
          var e_0 = $p_0;
          printStackTrace(e_0);
        } else {
          throw $p_0;
        }
      }
    }
    return Unit_instance;
  };
}
function onCancel(_this__u8e3s4, check, block) {
  var tmp;
  if (check === VOID) {
    tmp = onCancel$lambda;
  } else {
    tmp = check;
  }
  check = tmp;
  var running = {_v: true};
  var tmp_0 = CoroutineScope(_this__u8e3s4);
  launch(tmp_0, VOID, VOID, onCancel$slambda(running, check, block));
  // Inline function 'kotlin.AutoCloseable' call
  return new onCancel$$inlined$AutoCloseable$1(running);
}
function onCancel$lambda() {
  return true;
}
function onCancel$slambda$slambda($running, $check, $block) {
  return constructCallableReference(function *($this$withContext, $completion) {
    var tmp;
    try {
      while ($running._v && $check()) {
        // Inline function 'korlibs.time.seconds' call
        var tmp$ret$0 = toDuration_0(0.1, DurationUnit_SECONDS_getInstance());
        yield* delay(tmp$ret$0, $completion);
      }
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        tmp_0 = $running._v ? $block(true) : void 0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    finally {
      if ($running._v)
        $block(false);
    }
    return Unit_instance;
  }, 1);
}
function onCancel$slambda($running, $check, $block) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp = CoroutineName.b1u('onCancel');
    yield* withContext(tmp, onCancel$slambda$slambda($running, $check, $block), $completion);
    return Unit_instance;
  }, 1);
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.x9y(Unit_instance);
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.o('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.od();
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.qd(tmp$ret$6);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$8 = _Result___init__impl__xyqfz8(value);
      completion.qd(tmp$ret$8);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function get_NativeThreadThread_isSupported() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return NativeThreadThread_isSupported;
}
var NativeThreadThread_isSupported;
function get_warnSleep() {
  _init_properties_NativeThread_js_kt__xin1zw();
  var tmp0 = warnSleep$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('warnSleep', 0, tmp, _get_warnSleep_$ref_if4wvj(), null);
  tmp0.k3();
  return Unit_instance;
}
var warnSleep$delegate;
function NativeNativeThread_getId(thread) {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_current() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_start(name, isDaemon, priority, code) {
  _init_properties_NativeThread_js_kt__xin1zw();
  // Inline function 'kotlin.TODO' call
  throw NotImplementedError.le();
}
function NativeThreadThread_sleep(time) {
  _init_properties_NativeThread_js_kt__xin1zw();
  get_warnSleep();
  var start = Monotonic_instance.ck();
  // Inline function 'korlibs.concurrent.thread.NativeThreadThread_spinWhile' call
  $l$loop: while (compareTo_0(ValueTimeMark__elapsedNow_impl_eonqvs(start), time) < 0) {
  }
}
function warnSleep$delegate$lambda() {
  _init_properties_NativeThread_js_kt__xin1zw();
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
function _get_warnSleep_$ref_if4wvj() {
  return constructCallableReference(() => {
    get_warnSleep();
    return Unit_instance;
  }, 0, 0, 53);
}
var properties_initialized_NativeThread_js_kt_lgs6ti;
function _init_properties_NativeThread_js_kt__xin1zw() {
  if (!properties_initialized_NativeThread_js_kt_lgs6ti) {
    properties_initialized_NativeThread_js_kt_lgs6ti = true;
    NativeThreadThread_isSupported = false;
    warnSleep$delegate = lazy(warnSleep$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForInterface(BaseLockWithNotifyAndWait, 'BaseLockWithNotifyAndWait');
protoOf(LockImpl).r9w = notify$default;
initMetadataForClass(LockImpl, 'LockImpl', VOID, VOID, [BaseLockWithNotifyAndWait]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForClass(FixedPoolNativeThreadDispatcher, 'FixedPoolNativeThreadDispatcher', VOID, VOID, [AutoCloseable, Delay], [1]);
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, DisposableHandle]);
initMetadataForClass(NativeThreadDispatcher, 'NativeThreadDispatcher', NativeThreadDispatcher.y9x, VOID, [AutoCloseable, Delay], [1]);
initMetadataForClass(onCancel$$inlined$AutoCloseable$1, VOID, VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_1);
protoOf(PreferSyncIo).ae = get;
protoOf(PreferSyncIo).dp = fold;
protoOf(PreferSyncIo).cp = minusKey;
protoOf(PreferSyncIo).ep = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
protoOf(runBlockingNoSuspensions$1$context$1).ae = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).cp = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).ce = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).j1u = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1, VOID, VOID, VOID, [Continuation]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(Lock, 'Lock', Lock, VOID, [BaseLockWithNotifyAndWait]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_3 = new Companion_2();
//endregion
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance385avdqdxp6qt,
  Companion_getInstance_2 as Companion_getInstanceqfkejm4vy6f5,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  FixedPoolNativeThreadDispatcher as FixedPoolNativeThreadDispatcher1vd3m0y3p4oiv,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke as invoke2sf88d1xeuyqh,
  onCancel as onCancel134048q5p9j85,
  runBlockingNoSuspensions as runBlockingNoSuspensions25hsuevf2mle,
};
//endregion
